/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'

interface AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanelProps {
  dataUltimasVisitasDomiciliares: LocalDate[]
  qtdVisitasDomiciliares: number
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel({
  dataUltimasVisitasDomiciliares,
  qtdVisitasDomiciliares,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanelProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon icon='houseFilled' size={1} color={iconColor} />
          <Heading level={4}>Visitas domiciliares (últimos 36 meses)</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Quantidade'>{qtdVisitasDomiciliares}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Últimas visitas' placeholder='-'>
          {dataUltimasVisitasDomiciliares?.map(formatDate).join(' e ')}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}
